import { useMemo } from 'react'
import { orderByToSortModel } from '@user/components/xGrid'
import { GridColDef } from '@mui/x-data-grid-pro'
import { useSelector } from 'react-redux'
import { selectImportPageState } from '@user/store/import/slice'

type Props = {
  columns: GridColDef[]
}

export function useSortModel(props: Props) {
  const {
    filterSet: { orderBy },
  } = useSelector(selectImportPageState)

  const sortModel = useMemo(
    () =>
      props?.columns?.length === 0 ? undefined : orderByToSortModel(orderBy),
    [orderBy, props?.columns?.length],
  )

  return { sortModel }
}
